import { LiaDataElement } from '@liasoft/lit-ui';
import { html } from 'lit';
import { errorPanel, loadingPanel } from '../../shared/ui/templates.js';
import { loadAccounts } from '../state/context.js';
import './dashboard.js';
import './welcome.js';

/**
 * The front page: the developer's own overview.
 *
 * `/` is the sidebar's Overview, and it is the same page whether somebody has just signed in, opened a
 * bookmark, reloaded, or clicked the entry - every team is one click away in the sidebar, so nothing
 * here decides where they "really" wanted to go. The one exception is somebody with no team beyond the
 * personal one everybody has: they get the welcome, which says what personal use is and how a team is
 * created, because an overview of nothing would say less.
 */
export class UserLanding extends LiaDataElement
{
   static properties = { accounts: { state: true } };

   constructor()
   {
      super();
      this.accounts = null;
   }

   async load(signal)
   {
      const accounts = await loadAccounts();

      if (signal?.aborted)
      {
         return;
      }

      this.accounts = accounts;
   }

   get welcome()
   {
      return this.accounts.every(entry => entry.personal);
   }

   render()
   {
      if (this.error)
      {
         return html`<div class="p-3">${errorPanel(this.error, () => this.reload())}</div>`;
      }

      if (!this.accounts)
      {
         return loadingPanel('Loading your teams');
      }

      if (this.welcome)
      {
         return html`<user-welcome></user-welcome>`;
      }

      return html`<user-dashboard></user-dashboard>`;
   }
}

customElements.define('user-landing', UserLanding);
